<template>
  <div class="icon-dropdown" @click="toggleColumnMenu" v-click-outside="hideColumnMenu">
    <font-awesome-icon icon='caret-down' aria-label="Select item"/>
    {{ $props.title }}
    <ul ref='menu' class="dropdown hide">
      <slot/>
    </ul>
  </div>
</template>

<script>
  import dropdownable from '@mixins/dropdownable'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    mixins: [dropdownable],
    components: {
      FontAwesomeIcon
    },
    props: {
      title: String
    }
  }
</script>
